export interface IGenerateOrderOperation {
  orderId: number;
  shopProviderKey: string;
  operationId: string;
}
